// import icon from "../../../../assets/images/leftMenu/basePortal/icon_menu.png"
let icon = "icon-portal-menu_meau"
export default {
  name: "导航菜单",
  id: "",
  type: "cxSystemNav",
  componentType:"cxNavMenu",
  thumbnail: icon,
  typeId: "",
  children: []
}
